export default __webpack_public_path__ + "static/remembergrocerybot-05a3e7324734e07d6f0de1cd57bfcf59.png";